/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { BaseURL, deepCopy, getCookie, objectByString, saveJobBasic, shadeColor } from "../components/Common";
import { Palette, MANUFACTURER } from "../AppConfig";
import * as PaperIO from "../components_designer/layout/PaperFunctions";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Avatar from "@material-ui/core/Avatar";
import deepPurple from "@material-ui/core/colors/deepPurple";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";
import { DESIGNER_PAGE } from "../redux_store/appState";
import ManageUser from "./ManageUser";
import { Drawer, IconButton, Paper } from "@material-ui/core";
import Admin from "../admin/Admin";
import BSL_Button from "../components/BSL_Button";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        top: 0,
        left: 0,
        right: 0,
        position: "fixed",
        zIndex: 9999,
        textAlign: "left",
    },
    grow: {
        flexGrow: 1,
        font: "22pt " + theme.typography.fontFamily,
    },
    menuButton: {
        marginRight: -12,
    },
    backButton: {
        marginRight: 0,
    },
    purpleAvatar: {
        margin: 5,
        color: "#fff",
        backgroundColor: deepPurple[500],
        marginBottom: "6px",
        alignSelf: "flex-end",
        border: theme.brand.FIELDERS ? "2px solid white" : "0px solid white",
        cursor: "pointer",
    },
    compactAvatar: {
        width: "28px",
        height: "28px",
        margin: "2px",
        fontSize: "small",
    },
    expandIcon: {
        marginBottom: "16px",
        alignSelf: "flex-end",
        color: theme.brand.FIELDERS ? "white" : Palette.Lysaght.DarkBlue,
        cursor: "pointer",
    },
    designer: {
        color: "#5AC3E4",
        font: "38pt " + Palette.Lysaght.FontFamily,
        fontWeight: 900,
        paddingLeft: "5px",
    },
    userName: {
        font: "9pt " + theme.typography.fontFamily,
        fontWeight: "600",
    },
    userNameLysaght: {
        color: Palette.Lysaght.DarkBlue,
        font: "600 14pt " + Palette.Lysaght.FontFamily,
        textTransform: "uppercase",
    },
    businessName: {
        font: "7pt " + theme.typography.fontFamily,
        fontWeight: "100",
    },
    businessNameLysaght: {
        font: "10pt " + Palette.Lysaght.FontFamily,
        fontWeight: "100",
        color: "black",
    },
    testHeader: {
        font: "7pt " + theme.typography.fontFamily,
        fontWeight: "100",
        marginBottom: theme.brand.FIELDERS ? "1px" : "5px",
        marginLeft: "20px",
        alignSelf: "flex-end",
    },
    testHeaderLg: {
        marginBottom: theme.brand.FIELDERS ? "0px" : "10px",
        font: "9pt " + theme.typography.fontFamily,
    },
    greybar: {
        width: "1px",
        color: "#E4E4E3",
        backgroundColor: "#E4E4E3",
        height: "32px",
        margin: "6px 4px 6px 10px",
    },
    admin_drawer_root: {
        top: "0px",
        left: "0px",
        width: "95%",
        height: "-webkit-fill-available",
        display: "flex",
        overflow: "hidden",
        position: "fixed",
        textAlign: "left",
        borderLeft: "3px solid #0000001f",
        borderRadius: "0px",
        flexDirection: "column",
        backdropFilter: "blur(4px)",
        backgroundColor: "#edf0f3e8",
        zIndex: 2000,
    },
}));

export default function TopBar(props) {
    const classes = useStyles();
    const app = useSelector((state) => state.app);
    const job = useSelector((state) => state.job);
    const { page, user } = app;
    const [openManageUser, setOpenManageUser] = React.useState(false);
    const [adminDrawer, setAdminDrawer] = React.useState(null);
    const [minimised, setMinimised] = React.useState(false);
    const this_MANUFACTURER = objectByString(MANUFACTURER, window.brand);

    React.useEffect(() => {
        if (!user || !app.logged_user_code) return;

        if (job?.id || window.loading_job_id) {
            let id = job?.id ? job?.id : window.loading_job_id;
            document.title = "#" + id + " - " + this_MANUFACTURER.SoftwareName + (window.debug ? " : Debug" : "");
            let url = "/app";
            if (window.debug) {
                let locref = window.location.href;
                if (locref.includes("use_cache")) url += "?use_cache";
                if (locref.includes("no_eng")) url += "_no_eng";
            }
            url += "/?job=" + id;

            if (window.location.href.toLowerCase().includes("brand=centenary")) url += "&brand=centenary";
            window.history.replaceState(null, document.title, url);
        } else {
            document.title = this_MANUFACTURER.SoftwareName + (window.debug ? " : Debug" : "");
            let url = "/app/";
            if (window.location.href.toLowerCase().includes("brand=centenary")) url += "?brand=centenary";
            window.history.replaceState(null, document.title, url);
        }
    }, [job, page]);

    let display_name = "No User Loaded";
    let display_business_name = "";
    let let_user_code = "?";
    if (user) {
        if (user.DisplayName) display_name = user.DisplayName;
        else if (user.FirstName) display_name = user.FirstName + " " + user.LastName;
        else display_name = user.id;
        display_business_name = user.BusinessDetails.Name;
        let_user_code = user.UserCode;
    }

    let compact = false;
    if (page === DESIGNER_PAGE) compact = true;

    let display_role = user?.RoleName;
    if (display_role)
        display_role = display_role
            .replace(/([A-Z])/g, " $1")
            .trim()
            .replace("B B C", "BBC");

    let this_Palette = objectByString(Palette, user?.Brand || window.brand);
    let background_colour = String(this_Palette?.prod);
    if (window.beta) {
        background_colour = String(this_Palette?.beta);
    } else if (window.location.href.includes("localhost")) {
        background_colour = String(this_Palette?.debug);
    } else if (window.location.href.includes("test.")) {
        background_colour = String(this_Palette?.test);
    }

    React.useEffect(() => {
        if (window.beta) {
            background_colour = String(this_Palette?.beta);
        }
    }, [window.beta]);

    let background_colour_grad =
        "linear-gradient(0.25turn, " + background_colour + ", " + shadeColor(background_colour, 12) + ")";

    let logoImg = this_MANUFACTURER?.Logo;
    let user_token = getCookie("CDS_token");
    let user_SFusername = getCookie("SF_user");

    return (
        <div className={classes.root}>
            <AppBar className="modal-open" position="fixed" style={{ width: "100vw", left: 0 }}>
                <Toolbar
                    variant="dense"
                    style={{
                        minHeight: compact ? "42px" : "100px",
                        background: background_colour_grad,
                        paddingBottom: window.FIELDERS ? "5px" : "3px",
                        position: "relative", // Needed for absolute positioning of the swipe
                        overflow: "hidden", // Ensures the swipe doesn't extend outside the toolbar
                        paddingRight: "50px",
                    }}
                >
                    <div
                        style={{
                            flex: 4,
                            alignSelf: "flex-end",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "end",
                        }}
                    >
                        {this_MANUFACTURER.Name === "Fielders" && logoImg && (
                            <img
                                src={BaseURL(String(logoImg))}
                                style={{ maxHeight: compact ? (window.LYSAGHT ? "18px" : "26px") : "40px" }}
                            />
                        )}
                        {this_MANUFACTURER.Name === "Lysaght" && (
                            <>
                                <img src={BaseURL(String(logoImg))} style={{ maxHeight: compact ? "30px" : "54px" }} />
                                <div className={classes.greybar} style={compact ? { height: "21px" } : {}} />
                                <div className={classes.designer} style={compact ? { fontSize: "22pt" } : {}}>
                                    DESIGNER
                                </div>
                            </>
                        )}
                        {window.beta || window.test || window.debug ? (
                            <div
                                className={classes.testHeader + (!compact ? " " + classes.testHeaderLg : "")}
                                style={this_MANUFACTURER.Name === "Lysaght" ? { color: "grey" } : {}}
                            >
                                {window.beta ? "BETA" : window.debug ? "DEBUG" : "TEST"} ENVIRONMENT
                            </div>
                        ) : null}
                    </div>

                    {!compact && (
                        <div
                            style={{
                                textAlign: "right",
                                paddingRight: "5px",
                                paddingBottom: "9px",
                                alignSelf: "flex-end",
                                display: "flex",
                                flexDirection: "column",
                            }}
                        >
                            <span className={window.LYSAGHT ? classes.userNameLysaght : classes.userName}>
                                {display_name}
                            </span>
                            {display_role && (
                                <span className={window.LYSAGHT ? classes.businessNameLysaght : classes.businessName}>
                                    {display_role} User
                                </span>
                            )}
                            <span className={window.LYSAGHT ? classes.businessNameLysaght : classes.businessName}>
                                {display_business_name}
                            </span>
                        </div>
                    )}
                    <Avatar
                        className={classes.purpleAvatar + " " + (compact ? classes.compactAvatar : "")}
                        src={user?.Avatar ? user?.Avatar : ""}
                        onClick={() => setOpenManageUser(!openManageUser)}
                    >
                        {user?.Avatar ? "" : let_user_code}
                    </Avatar>
                    <ExpandMoreIcon
                        r
                        className={classes.expandIcon}
                        style={{ marginBottom: compact ? "4px" : "16px" }}
                        onClick={() => setOpenManageUser(!openManageUser)}
                    />
                </Toolbar>
            </AppBar>
            {openManageUser && (
                <ManageUser open={openManageUser} toggleDrawer={() => setOpenManageUser(!openManageUser)} />
            )}

            {Number(user?.Role) >= 91 && (
                <>
                    <BSL_Button
                        onClick={() => setAdminDrawer(!adminDrawer)}
                        color="primary"
                        style={{
                            alignSelf: "center",
                            zIndex: "9999",
                            position: "fixed",
                            left: "calc(-200px + 100vw)",
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                            padding: "5px 10px",
                            border: "5px",
                            lineHeight: "1",
                            fontSize: "small",
                            boxShadow: "rgb(255 255 255 / 45%) 2px 2px 4px",
                        }}
                    >
                        {adminDrawer ? "Close" : "Admin"}
                    </BSL_Button>
                    {Number(user?.Role) >= 99 && window.debug && user?.id.includes("kevinchan") && (
                        <>
                            <BSL_Button
                                onClick={() => {
                                    localStorage.clear();
                                    let brand = window.LYSAGHT ? "" : "?b=Lysaght";
                                    let redirect = "/auth/" + brand;
                                    if (window.location.href.startsWith("http://localhost:3000"))
                                        redirect = "http://localhost:62027/auth/" + brand;
                                    window.location.href = redirect;
                                }}
                                color="primary"
                                style={{
                                    alignSelf: "center",
                                    zIndex: "9999",
                                    position: "fixed",
                                    right: "225px",
                                    borderBottomLeftRadius: "10px",
                                    borderBottomRightRadius: "10px",
                                    padding: "5px 10px",
                                    border: "5px",
                                    lineHeight: "1",
                                    fontSize: "small",
                                    boxShadow: "rgb(255 255 255 / 45%) 2px 2px 4px",
                                }}
                            >
                                {window.LYSAGHT ? "CDS" : "LLD"}
                            </BSL_Button>
                        </>
                    )}
                    <Drawer
                        anchor="left"
                        open={adminDrawer}
                        onClose={() => setAdminDrawer(null)}
                        disableEnforceFocus={true}
                        hideBackdrop={minimised ? true : false}
                        BackdropProps={{ invisible: minimised ? true : false }}
                    >
                        <div
                            className={classes.admin_drawer_root}
                            style={
                                minimised == 2 ? { maxHeight: "400px" } : minimised == 1 ? { maxHeight: "75px" } : {}
                            }
                        >
                            <Paper elevation={20} style={{ width: "100%", height: "100%" }}>
                                <Admin minimised={minimised} setMinimised={setMinimised} />
                                <IconButton
                                    aria-label="close"
                                    style={{
                                        position: "absolute",
                                        top: "3px",
                                        right: "5px",
                                    }}
                                    onClick={() => {
                                        setAdminDrawer(!adminDrawer);
                                    }}
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Paper>
                        </div>
                    </Drawer>
                </>
            )}
            {!window.location.href.toLowerCase().includes("preprod") && user?.BetaUser === "true" && (
                <>
                    <BSL_Button
                        onClick={() => {
                            if (job) {
                                var save_job = deepCopy(job);

                                if (app?.user && save_job)
                                    //&& !app?.user?.id.includes("diego.portela"))
                                    save_job.LastEditor = {
                                        id: app.user.id,
                                        DisplayName: app.user.DisplayName,
                                        UserCode: app.user.UserCode,
                                        _session_id: "",
                                        _ts: Date.now(),
                                    };

                                saveJobBasic(save_job, false);
                                window.svg = null;
                                window.svg_data = null;
                                window.job = null;
                                PaperIO.ClearAll();
                            }

                            window.location.href = window.location.href.includes("lysaght")
                                ? `https://preprod.lysaghtlivingdesigner.lysaght.com/app/?init-beta=""&CTK=${user_token}&SFU=${user_SFusername}`
                                : `https://preprod.centenarydesignsuite.fielders.com.au/app/?init-beta=""&CTK=${user_token}&SFU=${user_SFusername}`;
                        }}
                        color="primary"
                        style={{
                            alignSelf: "center",
                            zIndex: "9999",
                            position: "fixed",
                            left: "calc(-248px + 100vw)",
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                            padding: "5px 10px",
                            border: "5px",
                            lineHeight: "1",
                            fontSize: "small",
                            boxShadow: "rgb(255 255 255 / 45%) 2px 2px 4px",
                        }}
                    >
                        Pre
                    </BSL_Button>
                </>
            )}
            {window.beta && (
                <>
                    <BSL_Button
                        onClick={() =>
                            (window.location.href =
                                window.brand === "Lysaght"
                                    ? `https://lysaghtlivingdesigner.lysaght.com/app/`
                                    : `https://centenarydesignsuite.fielders.com.au/`)
                        }
                        color="primary"
                        style={{
                            alignSelf: "center",
                            zIndex: "9999",
                            position: "fixed",
                            left: "calc(-260px + 100vw)",
                            borderBottomLeftRadius: "10px",
                            borderBottomRightRadius: "10px",
                            padding: "5px 10px",
                            border: "5px",
                            lineHeight: "1",
                            fontSize: "small",
                            boxShadow: "rgb(255 255 255 / 45%) 2px 2px 4px",
                        }}
                    >
                        Prod
                    </BSL_Button>
                </>
            )}
        </div>
    );
}
